import { useTabState } from 'reakit/Tab';
import Image from 'next/image';
import cc from 'classnames';

import styles from '@/styles/pages/home.module.css';
import HomeSectionHero from './HomeSectionHero';
import Tab from './Tab';
import TabList from './TabList';
import TabPanel from './TabPanel';

export default function BusinessesTabs() {
  const tabBusinesses = useTabState({ selectedId: `team-efficiency` });

  return (
    <>
      <div
        className={cc(
          styles.gridBusinesses,
          styles.gridTabs,
          `my-8 lg:mb-12 md:pt-0 pt-1 md:mt-0`,
        )}
      >
        <TabList
          tab={tabBusinesses}
          aria-label="Graphcms For Businesses"
          withBottomBorder
          className="justify-center items-center h-full col-start-1 lg:col-start-2 text-light-haiti"
        >
          <Tab
            tab={tabBusinesses}
            activeColor="text-azure-blue"
            id="team-efficiency"
          >
            Team Efficiency
          </Tab>
          <Tab
            tab={tabBusinesses}
            activeColor="text-azure-blue"
            id="scalability"
            className="mx-8"
          >
            Scalability
          </Tab>
          <Tab
            tab={tabBusinesses}
            activeColor="text-azure-blue"
            id="time-to-market"
          >
            Time to Market
          </Tab>
        </TabList>
      </div>

      <div>
        <TabPanel
          tab={tabBusinesses}
          id="team-efficiency"
          className={cc(
            styles.gridBusinesses,
            `focus:outline-none lg:min-h-[453px]`,
          )}
        >
          <div>
            <HomeSectionHero
              badge="Graphcms For Businesses"
              title="Let All Your Investments Work Together"
              description="Break down your silos by federating your content. GraphCMS can Integrate all your existing backend services and business processes to deliver cutting-edge digital experiences from a unified content layer."
              colors={{ badge: `text-azure-blue` }}
              cta={{
                href: `/for-businesses`,
                label: `Explore GraphCMS for Businesses`,
              }}
            />
          </div>

          <Image
            src="/images/home/team-efficiency.svg"
            alt="Integrate all your existing backends and services to deliver content from a single source"
            width={522}
            height={452}
          />
        </TabPanel>

        <TabPanel
          tab={tabBusinesses}
          id="scalability"
          className={cc(
            styles.gridBusinesses,
            `focus:outline-none lg:min-h-[453px]`,
          )}
        >
          <div>
            <HomeSectionHero
              badge="Graphcms For Businesses"
              title="We’ll Scale With You In Every Direction"
              description="GraphCMS is used by ambitious teams across the world, powering modern SaaS products, multilingual streaming platforms, and high-volume publishing portals."
              colors={{ badge: `text-azure-blue` }}
              cta={{
                href: `/for-businesses`,
                label: `Explore GraphCMS for Businesses`,
              }}
            />
          </div>

          <Image
            src="/images/home/scalability.svg"
            alt="Scalability illustration with information as daily traffic, uptime, active projects, APIs federated, and orders processed"
            width={582}
            height={475}
          />
        </TabPanel>

        <TabPanel
          tab={tabBusinesses}
          id="time-to-market"
          className={cc(
            styles.gridBusinesses,
            `focus:outline-none lg:min-h-[453px]`,
          )}
        >
          <div>
            <HomeSectionHero
              badge="Graphcms For Businesses"
              title="Focus On Your Business Model"
              description="Rapidly validate and innovate on your business model to match the speed of business. Stop compromising on your goals of delivering high-performance digital experiences because of legacy web technologies."
              colors={{ badge: `text-azure-blue` }}
              cta={{
                href: `/for-businesses`,
                label: `Explore GraphCMS for Businesses`,
              }}
            />
          </div>

          <Image
            src="/images/home/time-to-market.svg"
            alt="Time to the market illustration showing a workflow that integrates the team and services with GraphCMS"
            width={608}
            height={377}
          />
        </TabPanel>
      </div>
    </>
  );
}
